// extracted by mini-css-extract-plugin
module.exports = {"bgCover":"ImageCard_bgCover___yZ8x","bgContain":"ImageCard_bgContain__m9h9M","imageGallery":"ImageCard_imageGallery__2c3oa","customStyle":"ImageCard_customStyle__NUKJr"};